import React from "react";
import { Link } from "react-router-dom";

const LOGO_URL = "/munnexa-logo.png";

const COLUMNS = [
  { title: "Solutions", items: [
    { label: "AI Chatbot", to: "/solutions/ai-chatbot" },
    { label: "Voice AI", to: "/solutions/voice-ai" },
    { label: "CRM Brain", to: "/solutions/crm-brain" },
    { label: "Automation", to: "/solutions/automation" },
  ]},
  { title: "Company", items: [
    { label: "About", to: "/about" },
    { label: "Case Studies", to: "/case-studies" },
    { label: "Careers", to: "/careers" },
    { label: "Press", to: "/press" },
  ]},
  { title: "Legal", items: [
    { label: "Privacy", to: "/privacy" },
    { label: "Terms", to: "/terms" },
    { label: "DPA", to: "/dpa" },
    { label: "Security", to: "/security" },
  ]},
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 mt-10 px-6 pt-16 pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto grid md:grid-cols-4 gap-10">
        <div>
          <Link to="/" className="flex items-center gap-3 group">
            <div className="w-14 h-14 rounded-xl overflow-hidden ring-1 ring-white/15 shadow-lg">
              <img src={LOGO_URL} alt="MUNNEXA" className="w-full h-full object-cover" />
            </div>
            <div className="leading-tight">
              <div className="font-[Outfit] font-bold text-xl text-gradient">MUNNEXA</div>
              <div className="font-mono text-[10px] tracking-[0.3em] text-cyan-300/80 mt-0.5">THE NEXT ERA</div>
            </div>
          </Link>
          <p className="mt-4 text-sm text-white/55 max-w-xs">A Singapore-born AI growth lab engineering the next era of business.</p>
        </div>

        {COLUMNS.map((col) => (
          <div key={col.title}>
            <div className="font-mono text-[10px] uppercase tracking-widest text-white/55 mb-3">{col.title}</div>
            <ul className="space-y-2 text-sm text-white/70">
              {col.items.map((i) => (
                <li key={i.label}>
                  <Link to={i.to} className="hover:text-white transition" data-testid={`footer-link-${i.label.toLowerCase().replace(/\s+/g, "-")}`}>{i.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="font-mono text-[11px] text-white/40">© {new Date().getFullYear()} MUNNEXA · Singapore</div>
        <div className="font-mono text-[11px] text-white/40">Built for the next era. ◇</div>
      </div>
    </footer>
  );
}
